export enum AttachmentEnum {
  CONTRACT = 'CONTRACT',
  DISTRACT = 'DISTRACT',
  PROPOSAL = 'PROPOSAL',
}
